var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"label":"Dar de alta al paciente","type":"is-dark"}},[_c('b-button',{attrs:{"type":"is-primary","size":"is-small","icon-left":"user-times","loading":_vm.isLoading},on:{"click":_vm.ConfirmUnassign}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }